/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationOptionsForCostSavings extends models.RecommendationOptionsBase {
    constructor() {
        super();
        this.setDiscriminator("RecommendationOptionsForCostSavings");
    }

    getFixupPrototypeFunction() { return RecommendationOptionsForCostSavings.fixupPrototype; }

    static newInstance(model: Partial<RecommendationOptionsForCostSavings>): RecommendationOptionsForCostSavings {
        let obj = Object.assign(new RecommendationOptionsForCostSavings(), model);
        RecommendationOptionsForCostSavings.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationOptionsForCostSavings>): RecommendationOptionsForCostSavings {
        if (!model) return null;
        return RecommendationOptionsForCostSavings.newInstance(<RecommendationOptionsForCostSavings> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationOptionsForCostSavings) {
        if (!obj) return;

        models.RecommendationOptionsForCostSavings.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationOptionsForCostSavings): boolean {
        if (models.RecommendationOptionsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationOptionsForCostSavings.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
